import { InputContainer, DatePicker } from 'components/ideal-core-ui'
import { Button } from 'reactstrap'
import { NumericFormat } from 'react-number-format'
import cn from 'classnames'
import { getCurrency } from 'utils/authService'
import { utcDate, timezoneDate } from 'utils/helpers'
import s from './AddSpend.scss'

const AddSpend = ({ itemDetails, changeProperty, saveDetails }) => {
  return (
    <>
      <div className={s.itemDetails}>
        <DatePicker
          className={s.dayPicker}
          value={itemDetails.date ? timezoneDate(itemDetails.date) : null}
          onChange={value => {
            const date = value && value !== null ? utcDate(value) : ''
            changeProperty(date, 'date')
          }}
        />
        <InputContainer
          type="text"
          placeholder="Spend Item"
          cb={value => changeProperty(value, 'name')}
          text={itemDetails.name}
        />
        <NumericFormat
          className={s.amount}
          thousandSeparator
          placeholder="Amount"
          decimalScale={2}
          allowNegative={false}
          value={itemDetails.value}
          prefix={getCurrency().symbol}
          onChange={formattedValue => {
            const stripValue = formattedValue.target.value.replace(/[^\d.-]/g, '')
            changeProperty(stripValue, 'value')
          }}
        />
      </div>
      {saveDetails && (
        <Button
          disabled={!itemDetails.name || !itemDetails.value || !itemDetails.date}
          className={cn(s.greenBtn, s.saveBtn)}
          onClick={saveDetails}
        >
          Add
        </Button>
      )}
    </>
  )
}

export default AddSpend
